import gql from 'graphql-tag'

export const QUERY_ACCOUNT_FRANCHISEE_PERMISSIONS = gql`
  query AccountFranchiseePermissions {
    accountFranchiseePermissions {
      offers_mobile
      view_offers_schedule_trade_results
      banners_mobile
      performance_mobile
      push_campaigns
      flyers_campaigns
      edit_cashback
      edit_points
      edit_user_register
      edit_offers_mobile_units
    }
  }
`
export const MUTATION_UPDATE_ACCOUNT_FRANCHISEE_PERMISSIONS = gql`
  mutation UpdateAccountFranchiseePermissions($data: AccountFranchiseePermissionsInput!) {
    updateAccountFranchiseePermissions(data: $data)
  }
`
